export default __webpack_public_path__ + "static/media/handicap-auditif.f920b630.svg";